import React from 'react';
import { ShareButton } from './Inputs';
import Post from '../../shared/Post';
import { RowFlexBox } from '../templates/Wrappers';
import { NiceDate } from '../../shared/UIFormatting';
import { DefaultURL } from '../../shared/Globals';
import FBContent from '../templates/FBContent';

const FeedCard: React.FC<{ post: Post, hideShare?: boolean }> = ({ post, hideShare }) => {

    return (
        <div className="card" style={{ overflowWrap: 'anywhere', padding: 12, fontSize: 12, lineHeight: "1.5em"}}>
            <div style={{ maxWidth: 600 }}>
                <FBContent contentType={post.contentType} content={post.content} />
            </div>
            <RowFlexBox style={{ justifyContent: 'space-between', marginTop: 10 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <span className="light">{post.author} - {NiceDate(post.posted)}</span>
                </div>
                {!hideShare && <ShareButton link={DefaultURL + 'feed/' + post.postId} />}
            </RowFlexBox>
        </div>
    );
};

export default FeedCard;

